import type { AlertEventStatus, AlertRuleType, AlertSchedule, AlertSeverity, AlertType, NotificationChannel } from '@rfleet/shared';

export interface AlertRow {
  id: string;
  ruleId: string | null;
  type: AlertType;
  severity: AlertSeverity;
  status: AlertEventStatus;
  vehicleId: string | null;
  driverId: string | null;
  tripId: string | null;
  placeId: string | null;
  occurredAt: string;
  lat: number | null;
  lon: number | null;
  address: string | null;
  titleAr: string;
  titleEn: string;
  data: Record<string, unknown>;
  assignedToId: string | null;
  acknowledgedAt: string | null;
  closedAt: string | null;
  closeNote: string | null;
  createdAt: string;
  vehicle: { id: string; plateAr: string; name: string | null } | null;
  driver: { id: string; fullName: string; phone: string } | null;
  trip: { id: string; number: string } | null;
  place: { id: string; name: string } | null;
  rule: { id: string; name: string } | null;
  assignedTo: { id: string; fullName: string } | null;
  acknowledgedBy: { id: string; fullName: string } | null;
  closedBy: { id: string; fullName: string } | null;
}

export interface AlertDetail extends AlertRow { actions: string[] }

export interface AlertSummary { open: number; critical: number; warning: number; info: number; acknowledged: number; today: number; byType: { type: AlertType; count: number }[] }

export interface RuleRow {
  id: string;
  name: string;
  type: AlertRuleType;
  severity: AlertSeverity;
  isEnabled: boolean;
  allVehicles: boolean;
  vehicleIds: string[];
  groupIds: string[];
  placeIds: string[];
  config: Record<string, number | boolean>;
  schedule: AlertSchedule | null;
  cooldownSec: number;
  recipientUserIds: string[];
  recipientRoleCodes: string[];
  channels: NotificationChannel[];
  notifyDriver: boolean;
  eventsLast7d: number;
}

export const severityTone = (s: AlertSeverity): 'danger' | 'warning' | 'info' => (s === 'CRITICAL' ? 'danger' : s === 'WARNING' ? 'warning' : 'info');
export const alertStatusTone = (s: AlertEventStatus): 'danger' | 'warning' | 'neutral' => (s === 'OPEN' ? 'danger' : s === 'ACKNOWLEDGED' ? 'warning' : 'neutral');
